"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _keycode = _interopRequireDefault(require("keycode"));
var _HiIcon = _interopRequireDefault(require("../HiIcon"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: (0, _objectSpread2.default)({}, theme.typography.body3, {
      display: 'inline-flex',
      marginRight: 4,
      width: 'fit-content',
      height: 24,
      borderRadius: 12,
      backgroundColor: '#e0e0e0',
      color: theme.palette.neutral.dark,
      padding: 8,
      alignItems: 'center',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '&$rightNavigation': {
        paddingRight: 2
      },
      '&$leftNavigation': {
        paddingLeft: 2
      },
      '&$deletable': {
        paddingRight: 2
      },
      '&$leftIcon': {
        paddingLeft: 2
      }
    }),
    leftNavigation: {},
    rightNavigation: {},
    deletable: {},
    leftIcon: {},
    icon: function icon(props) {
      var fontSize = props.iconSize || 20;
      return {
        marginRight: 4,
        fontSize: fontSize
      };
    },
    iconClickable: {
      cursor: 'pointer',
      '&:hover, &:focus': {
        color: theme.palette.primary.main
      }
    },
    eraseIcon: {
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      marginLeft: 4,
      position: 'relative',
      cursor: 'pointer',
      color: theme.palette.neutral.main,
      '&:hover, &:focus': {
        color: theme.palette.neutral.dark
      }
    },
    label: {
      userSelect: 'none',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    prefix: {
      whiteSpace: 'nowrap',
      color: theme.palette.neutral.dark,
      paddingRight: 4
    },
    navigate: {
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      backgroundColor: '#e0e0e0',
      color: theme.palette.neutral.normal,
      marginRight: 2,
      marginLeft: 2,
      borderRadius: 10,
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: theme.palette.primary.main,
        color: '#e0e0e0'
      },
      position: 'relative'
    },
    badge: {
      height: 16,
      paddingLeft: '2px',
      paddingRight: '8px'
    }
  };
});
var handleKeyDown = function handleKeyDown(e, fn) {
  if ((0, _keycode.default)(e) === 'space' || (0, _keycode.default)(e) === 'enter') {
    e.preventDefault();
    fn();
  }
};
var HiChip = function HiChip(props) {
  var className = props.className,
    fallbackImage = props.fallbackImage,
    icon = props.icon,
    _props$iconSize = props.iconSize,
    iconSize = _props$iconSize === void 0 ? 20 : _props$iconSize,
    id = props.id,
    img = props.img,
    label = props.label,
    labelIcon = props.labelIcon,
    onClick = props.onClick,
    onKeyDown = props.onKeyDown,
    onPrevious = props.onPrevious,
    onNext = props.onNext,
    onDelete = props.onDelete,
    prefix = props.prefix,
    onIconClick = props.onIconClick,
    title = props.title,
    titleDelete = props.titleDelete,
    titleIcon = props.titleIcon,
    titleImg = props.titleImg,
    titleNext = props.titleNext,
    titlePrevious = props.titlePrevious,
    style = props.style;
  var classes = useStyles(props);
  var chipIcon;
  if (icon) {
    var iconProps = {
      className: (0, _classnames.default)(classes.icon, (0, _defineProperty2.default)({}, classes.iconClickable, onIconClick)),
      id: "".concat(id, "-icon"),
      onClick: onIconClick,
      onKeyDown: function onKeyDown(event) {
        return handleKeyDown(event, onIconClick);
      },
      title: titleIcon,
      tabIndex: onIconClick ? 0 : -1
    };
    if (typeof icon === 'string') {
      chipIcon = /*#__PURE__*/_react.default.createElement(_HiIcon.default, (0, _extends2.default)({
        icon: icon
      }, iconProps));
    } else if ((0, _typeof2.default)(icon) === 'object') {
      chipIcon = (0, _objectSpread2.default)({}, icon);
      chipIcon.props = (0, _objectSpread2.default)({}, iconProps);
    }
  }
  var chipLabelIcon;
  if (labelIcon) {
    var _iconProps = {
      className: classes.icon,
      id: "".concat(id, "-labelIcon"),
      size: iconSize,
      title: titleIcon,
      tabIndex: -1
    };
    if (typeof labelIcon === 'string') {
      chipLabelIcon = /*#__PURE__*/_react.default.createElement(_HiIcon.default, (0, _extends2.default)({
        icon: labelIcon
      }, _iconProps));
    } else if ((0, _typeof2.default)(labelIcon) === 'object') {
      chipLabelIcon = (0, _objectSpread2.default)({}, labelIcon);
      chipLabelIcon.props = (0, _objectSpread2.default)({}, _iconProps, {
        style: {
          fontSize: props.iconSize || 20
        }
      });
    }
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    role: 'button',
    className: (0, _classnames.default)(classes.root, className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.leftNavigation, onPrevious), classes.rightNavigation, onNext), classes.deletable, onDelete), classes.leftIcon, icon)),
    title: title,
    onClick: onClick,
    onKeyDown: onKeyDown,
    tabIndex: onKeyDown ? '0' : '-1',
    style: style
  }, chipIcon, prefix && /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(id, "-prefix"),
    className: classes.prefix
  }, prefix), img && /*#__PURE__*/_react.default.createElement("img", {
    className: classes.badge,
    id: "".concat(id, "-badge"),
    src: img,
    alt: label,
    onError: function onError(e) {
      if (fallbackImage) {
        e.target.src = "".concat(fallbackImage);
      } else {
        e.target.style.display = 'none';
      }
    },
    title: titleImg
  }), labelIcon && chipLabelIcon, onPrevious && /*#__PURE__*/_react.default.createElement(_HiIcon.default, {
    className: (0, _classnames.default)(classes.navigate),
    id: "".concat(id, "-previous"),
    icon: "arrow_left",
    onClick: onPrevious,
    onKeyDown: function onKeyDown(event) {
      return handleKeyDown(event, onPrevious);
    },
    size: iconSize,
    title: titlePrevious,
    tabIndex: 0
  }), /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(id, "-label"),
    className: classes.label
  }, label), onNext && /*#__PURE__*/_react.default.createElement(_HiIcon.default, {
    className: (0, _classnames.default)(classes.navigate),
    id: "".concat(id, "-next"),
    icon: "arrow_right",
    onClick: onNext,
    onKeyDown: function onKeyDown(event) {
      return handleKeyDown(event, onNext);
    },
    size: iconSize,
    title: titleNext,
    tabIndex: 0
  }), onDelete && /*#__PURE__*/_react.default.createElement(_HiIcon.default, {
    classes: {
      root: classes.eraseIcon
    },
    id: "".concat(id, "-delete"),
    icon: "cancel",
    onClick: onDelete,
    onKeyDown: function onKeyDown(event) {
      return handleKeyDown(event, onDelete);
    },
    size: iconSize,
    title: titleDelete,
    tabIndex: 0
  }));
};
var _default = exports.default = HiChip;